<span *ngIf="!hideValues">{{ formatValue(0) }}</span>
<div [ngClass]="{ 'rounded-progress-bar-corners': roundedCorners }">
	<progress max="{{ maxValue }}" value="{{ value }}"></progress>
	<div class="progress-indicator">
		<span [style.margin-left.%]="percentageValue" *ngIf="value > 0">
			<span class="progress-indicator-marker"></span>
		</span>
	</div>
	<span *ngIf="!hideValues || showCurrentLimit" class="progress-value" [style.margin-left.%]="percentageValue">
		{{ formatValue(value) }}
	</span>
</div>
<span *ngIf="!hideValues">{{ formatValue(maxValue) }}</span>
